import { Injectable } from '@angular/core';
import {
  DataModuleControllerService,
  DataModuleWithRelations,
} from '@osos/shared/api';
import {
  IndexableLocalizedItem,
  LocalizedValueModel,
  Where,
} from '@osos/shared/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiUtilsService } from '../../api-utils/api-utils.service';

@Injectable()
export class ModuleDataService extends DataModuleControllerService {
  constructor(private apiHelper: ApiUtilsService) {
    super();
  }

  public getModulesWithIdenticalNames(
    name: LocalizedValueModel,
    id?: string,
  ): Observable<IndexableLocalizedItem[]> {
    const filter: Where<DataModuleWithRelations> =
      this.apiHelper.prepareLocalPropFilter({
        name,
        id,
      });

    return this.find(
      this.apiHelper.prepareFilter({
        where: filter,
        fields: { id: true, name: true },
      }),
    ).pipe(map((modules) => modules as Array<IndexableLocalizedItem>));
  }

  public countModulesWithNormalizedNameOf(
    value: string,
    id?: string,
  ): Observable<number> {
    const idCond = id ? { id: { neq: id } } : {};
    return this.count(
      this.apiHelper.prepareWhere<DataModuleWithRelations>({
        normalizedName: value,
        ...idCond,
      }),
    ).pipe(map((count) => count?.count || 0));
  }
}
